import { render, staticRenderFns } from "./printCusReceivable.vue?vue&type=template&id=0c4ef1d4&scoped=true&"
import script from "./printCusReceivable.vue?vue&type=script&lang=js&"
export * from "./printCusReceivable.vue?vue&type=script&lang=js&"
import style0 from "./printCusReceivable.vue?vue&type=style&index=0&id=0c4ef1d4&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ef1d4",
  null
  
)

component.options.__file = "printCusReceivable.vue"
export default component.exports